<div class="column" [ngClass]="{'highlighted ': index % 2 == 0}">
  <sc-padding>
    <sc-flex centered>
      {{lowerBound}}:00 - {{upperBound}}:00
    </sc-flex>
  </sc-padding>
  <sc-padding half>
    <sc-flex vertical stretchContent [gap]="8">
      @for(b of timeframes.bookings; track b) {
      <sc-tile (click)="handleItemClick(b)" [ngClass]="{'clickable': b.transportId}" [style]="(b.transportId && b.transportId==selectedTransportId) ? 'selected':'default'">
        <sc-padding half>
          <sc-flex vertical stretchContent [gap]="4">
            <!-- <div class="line"><sc-flex>{{b.style}}</sc-flex></div> -->
            @if(b.planningDate) {
            <div class="line">
              <sc-flex>
                <sc-icon iconClass="fa-calendar"></sc-icon>
                <sc-content-spacer half></sc-content-spacer>
                {{b.planningDate | timestamp}}
              </sc-flex>
            </div>
            }
            @if(b.identifier) {
            <div class="line">{{b.identifier}}</div>
            }
            @if(b.line1) {
            <div class="line">{{b.line1}}</div>
            }
            @if(b.carrier || b.numberPlate) {
            <div class="line"><strong>{{b.numberPlate}}</strong> {{b.carrier}}</div>
            }
            @if(b.supplier || b.reference) {
            <div class="line"><strong>{{b.reference}}</strong> {{b.supplier}}</div>
            }
          </sc-flex>
        </sc-padding>
      </sc-tile>
      }
    </sc-flex>
  </sc-padding>
</div>
